<nb-select [placeholder]="placeholder" fullWidth>
  <nb-option [value]="null">Any</nb-option>
  <nb-option [value]="'true'">Yes</nb-option>
  <nb-option [value]="'false'">No</nb-option>
</nb-select>
